import React, { useState, useEffect } from 'react';
import useRendicontazioneAdmin from '../../hooks/useRendicontazioneAdmin';
import { Spinner, Alert, Button } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import useArchivioRendicontazioniConfigTable from '../../configTable/useArchivioRendicontazioniConfigTable';
import RendicontazioneDettaglioModal from '../../components/RendicontazioneDettaglioModal/RendicontazioneDettaglioModal';
import { Dropdown } from 'react-bootstrap'; // Aggiungiamo Dropdown per coerenza

const ArchivioRendicontazioniPage = () => {
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const { isLoading, findLiquidate, getDettaglio } = useRendicontazioneAdmin();

    const [rendicontazioni, setRendicontazioni] = useState([]);
    const archivioConfigTable = useArchivioRendicontazioniConfigTable();

    const [showDettaglioModal, setShowDettaglioModal] = useState(false);
    const [selectedRendicontazione, setSelectedRendicontazione] = useState(null);
    const [dettaglioData, setDettaglioData] = useState([]);


    const openDettaglioModal = async (item) => {
        setSelectedRendicontazione(item);
        setShowDettaglioModal(true);
        const dettagli = await getDettaglio(item.id_rendicontazione); // Riutilizziamo la funzione dall'hook
        setDettaglioData(dettagli);
    };

    useEffect(() => {
        const fetchArchivio = async () => {
            const data = await findLiquidate({}); // Carica tutto l'archivio
            setRendicontazioni(data);
        };
        fetchArchivio();
    }, []);

      const actions = [
      {
          icon: 'bi-eye-fill text-info',
          label: 'Dettaglio',
          tooltip: 'Vedi Dettaglio',
          onClick: (item) => openDettaglioModal(item)
      }
  ];

return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
                <div className="container">
                    <div className="d-flex justify-content-between custom-card-header">
                        <div className="d-flex gap-3 custom-card-title my-2">
                            <div className="custom-icon-container">
                                <i className="bi custom-icon bi-archive-fill fs-2"></i>
                            </div>
                            <div className="align-self-center">
                                <span className="fs-4 d-block"><i><b>Archivio Rendicontazioni Liquidate</b></i></span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4">
                        {isLoading ? (
                            <LoadingTable loadingCol={5} />
                        ) : rendicontazioni.length > 0 ? (
                            <CustomTable
                                data={rendicontazioni}
                                columns={archivioConfigTable}
                                actions={actions}
                                actionsLabel="Dettaglio" // Aggiunge il titolo corretto alla colonna
                            />
                        ) : (
                            <div className='mt-5 pt-5 text-center'>
                                <p>Nessuna rendicontazione trovata nell'archivio.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            

            {/* --- BLOCCO DA AGGIUNGERE --- */}
            {/* Questo renderizza la modale di dettaglio solo quando un item è selezionato */}
            {selectedRendicontazione && (
                <RendicontazioneDettaglioModal
                    show={showDettaglioModal}
                    onHide={() => setShowDettaglioModal(false)}
                    isLoading={isLoading}
                    rendicontazione={selectedRendicontazione}
                    dettaglio={dettaglioData}
                />
            )}
            {/* --- FINE BLOCCO --- */}
        </>
    );
};

export default ArchivioRendicontazioniPage;